import axios from 'axios';
import React, { useState } from 'react'
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { CheckToken } from '../../login/AccessToken';
import { ChangeCursor } from './MiscFunctions';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';

function AddUpdateServices() {
    const { register, handleSubmit, formState: { errors }, setValue, setError, getValues, watch } = useForm();
    const [authToken, setAuthToken] = useState(sessionStorage.getItem('accessToken') !== undefined && sessionStorage.getItem('accessToken') !== null ? sessionStorage.getItem('accessToken') : "")
    const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
    const headers = {
        "Authorization": `Bearer ${authToken}`
    }
    const history = useHistory()

    useEffect(() => {
        if (sessionStorage.getItem('accessToken') == undefined && sessionStorage.getItem('accessToken') == null) {
            history.push('/login')
        }
    }, [])

    const Token = () => {
        const check = CheckToken()
        setAuthToken(sessionStorage.getItem('accessToken'))
        return check
    }

    const getDetailsOfConset = (data, e) => {
        e.preventDefault()
        ChangeCursor()
        if (Token()) {
            // console.log(data)

            var finalData = [];
            var post_data = {}
            post_data.id = data.facility_id
            post_data.name = data.facility_name
            post_data.type = data.facility_type
            post_data.alias = [];
            post_data.alias[0] = data.facility_id
            finalData[0] = post_data;
            axios.post(`${REACT_APP_BACKEND_ROUTE_URL}add_update_services/`, JSON.stringify(post_data),
                {
                    headers: headers
                })
                .then((res) => {
                    // console.log(res)
                    if (res.data.status !== "Failed") {
                        // console.log(res)
                        toast.success("Facility Added")
                    }
                    ChangeCursor()
                }).catch((err) => {
                    console.log(err)
                    toast.error(err)
                    ChangeCursor()
                })
        }
    }

    const facilityName = watch(["facility_name"]);
    useEffect(() => {
        if (facilityName[0] !== undefined || facilityName[0] !== null)
            getFacilityId()
    }, [facilityName])

    const getFacilityId = () => {
        const facilityname = getValues("facility_name")
        setValue("facility_id", facilityname.replaceAll(" ", "_"), { shouldTouch: true })
    }
    const navigate = (e) => {
        history.push(`/${e.target.id}`)
    }
    return (
        <div>
            <h1 style={{ paddingLeft: '32%' }}>Add/Update Services</h1>
            <Container>
                <Row style={{ marginTop: "2%", marginbottom: "2%", paddingBottom: '2%', width: '125%', marginLeft: '-10%' }} >
                    <Col >
                        <Card onClick={(e) => navigate(e)} id='register_patient' style={{ width: '100%', marginLeft: '-30%', height: '100%', cursor: 'pointer' }} >
                            <div style={{ display: "flex" }} id='register_patient' >
                                <img id='register_patient' src="/img/success-black-check-mark.svg" alt="" />
                                <h6 id='register_patient' style={{ paddingTop: '10%', whiteSpace: 'nowrap' }}>
                                    Register Patient
                                </h6>
                            </div>
                        </Card>
                    </Col>
                    <Col >
                        <Card onClick={(e) => navigate(e)} id='care_context' style={{ width: '140%', marginLeft: '-35%', height: '100%', cursor: 'pointer' }}>
                            <div style={{ display: "flex" }} id='care_context'>
                                <img src="/img/success-black-check-mark.svg" id='care_context' alt="" />
                                <h6 id='care_context' style={{ paddingTop: '8%', whiteSpace: 'nowrap' }}>
                                    Create & Link Visit Purpose
                                </h6>
                            </div>
                        </Card>
                    </Col>
                    {sessionStorage.getItem('subscription_type') !== undefined && sessionStorage.getItem('subscription_type') !== null
                        && sessionStorage.getItem('subscription_type').includes("Connector/Adaptor") ?
                        []
                        :
                        <Col >
                            <Card onClick={(e) => navigate(e)} id='upload_report' style={{ width: '100%', height: '100%', cursor: 'pointer' }}>
                                <div style={{ display: "flex" }} id='upload_report'>
                                    <img id='upload_report' src="/img/success-black-check-mark.svg" alt="" />
                                    <h6 id='upload_report' style={{ paddingTop: '10%', whiteSpace: 'nowrap' }}>
                                        Upload Report
                                    </h6>
                                </div>
                            </Card>
                        </Col>
                    }
                    <Col >
                        <Card onClick={(e) => navigate(e)} id='consent' style={{ width: '100%', height: '100%', cursor: 'pointer' }}>
                            <div style={{ display: "flex" }} id='consent'>
                                <img id='consent' src="/img/success-black-check-mark.svg" alt="" />
                                <h6 id='consent' style={{ paddingTop: '10%', whiteSpace: 'nowrap' }}>
                                    EHR Data Access
                                </h6>
                            </div>
                        </Card>
                    </Col>
                    <Col >
                        <Card onClick={(e) => navigate(e)} id='admin_services' style={{ width: '100%', height: '100%', cursor: 'pointer' }}>
                            <div style={{ display: "flex" }} id='admin_services'>
                                <img id='admin_services' src="/img/success-black-check-mark.svg" alt="" />
                                <h6 id='admin_services' style={{ paddingTop: '10%', whiteSpace: 'nowrap' }}>
                                    Admin Services
                                </h6>
                            </div>
                        </Card>
                    </Col>
                    <Col >
                        <Card onClick={(e) => navigate(e)} id='scan_qr' style={{ width: '100%', height: '100%', cursor: 'pointer' }} >
                            <div style={{ display: "flex" }} id='scan_qr' >
                                <img id='scan_qr' src="/img/success-black-check-mark.svg" alt="" />
                                <h6 id='scan_qr' style={{ paddingTop: '10%', whiteSpace: 'nowrap' }}>
                                    QR
                                </h6>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <div className="col-sm-12 col-md-12 col-lg-7" style={{ marginLeft: '22%' }}>
                <div className="contact-panel mb-50">
                    <form className="contact-panel__form" onSubmit={handleSubmit(getDetailsOfConset)}>
                        <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <i className="icon-news form-group-icon"></i>
                                    <input type="text" className="form-control" onChange={getFacilityId} placeholder='Enter Facility Name' name="facility_name"
                                        {...register("facility_name", {
                                            required: "Facility Name is required.",
                                        })} />
                                    {errors.facility_name && (
                                        <p className="errorMsg">{errors.facility_name.message}</p>
                                    )}
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <i className="icon-news form-group-icon"></i>
                                    <input type="text" className="form-control" placeholder='Facility ID' name="facility_id" readOnly
                                        {...register("facility_id", {
                                            required: "Facility ID is required.",
                                        })} />
                                    {errors.facility_id && (
                                        <p className="errorMsg">{errors.facility_id.message}</p>
                                    )}
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <i className="icon-news form-group-icon"></i>
                                    {/* <input type="text" className="form-control" placeholder='Facility Type' name="facility_type"
                                        {...register("facility_type", {
                                            required: "Facility Type is required.",
                                        })} /> */}
                                    <select className="form-control" name='facility_type'
                                        {...register("facility_type", {
                                            required: "Facility Type is required.",
                                        })}>
                                        <option value={"HIU"}>{"HIU"}</option>
                                        <option value={"HIP"}>{"HIP"}</option>
                                    </select>
                                    {errors.facility_type && (
                                        <p className="errorMsg">{errors.facility_type.message}</p>
                                    )}
                                </div>
                            </div>

                            <div className="col-12">
                                <button type="submit" className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10">
                                    <span>Add/Update</span> <i className="icon-arrow-right"></i>
                                </button>
                                <div className="contact-result"></div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AddUpdateServices